<template>
  <vue-html2pdf :enable-download="true" ref="pdf" filename="return invoice" :manual-pagination="true" :pdf-orientation="'portrait'" pdf-format="a4">
    <section slot="pdf-content">
      <div id="pdf-sale-invoice">
        <table cellpadding="10" id="table-pdf-invoice" style="width: 590px">
          <tr>
            <td class="padding-unset" width="w-1/2" align="left" style="text-align: left" v-if="sale.parent">
              <h1 style="text-align: left">{{ sale.parent.business_name }}</h1>
              <br />
              <span>
                <b>{{ sale.parent.business_name }}</b>
              </span>
              <br />
              <span>
                <b>{{ sale.parent.omma_license_number }}</b>
              </span>
              <br />
              <span> {{ sale.parent.address }}, {{ sale.parent.city && sale.parent.city.city_name }} </span>
              <br />
              <span> {{ sale.parent.state }}, {{ sale.parent.zipcode }} </span>
            </td>
            <td width="50%" align="right" valign="top">
              <h1 style="">RETURN INVOICE</h1>
            </td>
          </tr>
          <tr>
            <td class="padding-unset" width="50%" align="left" style="text-align: left">
              <br />
              <strong>Customer</strong><br />
              <span>
                <b>{{ sale.customer && sale.customer.business_name }}</b>
              </span>
              <br />
              <span>
                <b>{{ sale.customer && sale.customer.license_number }}</b>
              </span>
              <br />
              <span> {{ sale.customer && sale.customer.address }}, {{ sale.customer && sale.customer.city && sale.customer.city.city_name }} </span>
              <br />
              <span> {{ sale.customer && sale.customer.state }}, {{ sale.customer && sale.customer.postcode }} </span>
            </td>
            <td class="padding-unset" width="w-1/2" align="right">
              <span><strong>RETURN INVOICE #</strong> {{ sale.sales_return && sale.sales_return.return_code }}</span
              ><br />
              <span><strong>Return Date:</strong> {{ formatDate(sale.sales_return && sale.sales_return.return_date) }} </span>
            </td>
          </tr>
        </table>

        <table cellpadding="10" style="margin-top: 20px; border: 1px solid; border-spacing: 0px; width: 590px">
          <thead>
            <tr>
              <th>QTY</th>
              <th>WEIGHT TYPE</th>
              <th>DESCRIPTION</th>
              <th>UNIT PRICE</th>
              <th>Redeem Discount</th>
              <th>DISCOUNT</th>
              <th>AMOUNT</th>
            </tr>
          </thead>
          <tbody>
            <tr :key="i" v-for="(item, i) of return_items">
              <th>{{ item.return_qty | weightFilter }}</th>
              <th>{{ productWeightType(item) }}</th>
              <th>
                {{ item.category_name }} - {{ item.product_name }}
                {{ item.batch_number ? `( ${item.batch_number} )` : '' }}
              </th>
              <th>$ {{ item.price_per_unit | currencyFilter }}</th>
              <th>$ {{ item.return_redeem_dollar | currencyFilter }}</th>
              <th>$ {{ item.discount_amount | currencyFilter }}</th>
              <th>$ {{ calculateProductSubTotal(item) | currencyFilter }}</th>
            </tr>
            <tr>
              <th colspan="5"></th>
              <th colspan="total"><strong>DISCOUNT</strong></th>
              <th class="total">
                <strong>$ {{ sale.sales_return && sale.sales_return.tot_discount | currencyFilter }}</strong>
              </th>
            </tr>
            <tr>
              <th colspan="5"></th>
              <th colspan="total"><strong>Redeem Amount</strong></th>
              <th class="total">
                <strong>$ {{ calculateRedeemDollar | currencyFilter }}</strong>
              </th>
            </tr>
            <tr>
              <th colspan="5"></th>
              <th colspan="total"><strong>TOTAL</strong></th>
              <th class="total">
                <strong>$ {{ calculateTotal | currencyFilter }}</strong>
              </th>
            </tr>
          </tbody>
        </table>
        <div id="notices">
          <div>Payment : Cash</div>
          <div>Return Note : {{ sale.sales_return && sale.sales_return.return_note }}</div>
        </div>
        <div class="sign"></div>
      </div>
    </section>
  </vue-html2pdf>
</template>

<script>
import VueHtml2pdf from 'vue-html2pdf'
import { dateMixins } from '@/mixins/dateMixins.js'
import { weightMixins } from '@/utils/weightType'
import { paymentMixins } from '@/utils/paymentTypes'
import { mapState } from 'vuex'

export default {
  name: 'PdfReturnInvoice',
  props: {
    sale: {}
  },

  data: () => ({
    return_items: []
  }),

  mixins: [weightMixins, paymentMixins, dateMixins],

  computed: {
    ...mapState('product', ['categories']),

    // calculate product sub total
    calculateProductSubTotal() {
      return tr => {
        return tr.total_cost
      }
    },

    // calculate redeem dollar
    calculateRedeemDollar() {
      return this.return_items.reduce((acc, item) => acc + item.return_redeem_dollar, 0)
    },

    // calculate total
    calculateTotal() {
      return this.sale.sales_return.grand_total - this.calculateRedeemDollar
    },

    //  Check product weight type
    productWeightType() {
      return item => {
        return [this.categories.FLOWER, this.categories.SHAKE].includes(item.categoryId) ? item.weight_type : 'unit'
      }
    }
  },

  methods: {
    async createPDF() {
      this.return_items =
        this.sale &&
        this.sale.sales_return &&
        this.sale.sales_return.salesItemsReturn.reduce((acc, item) => {
          if (item.return_qty > 0) {
            acc.push(item)
          }

          return acc
        }, [])

      this.calculation()
    },

    async calculation() {
      this.return_items.map(item => {
        const tempProduct = this.sale.salesItems.find(x => x.productId === item.productId)
        item.weight_type = tempProduct.weight_type
        item.categoryId = tempProduct.product.categoryId
        item.category_name = tempProduct.product.category.category_name
        item.product_name = tempProduct.product.product_name
        item.batch_number = tempProduct.batch && tempProduct.batch.batch_number
      })
    }
  },

  async created() {
    await this.createPDF()
    this.$nextTick(() => {
      window.scrollTo(0, 0)
      this.$refs.pdf.downloadPdf()
      this.$emit('downloaded')
    })
  },

  // filters
  filters: {
    // currencyFilter rounded to 2 point
    currencyFilter(value) {
      return paymentMixins.methods.mathRound(Number(value), 2)
    },

    //weightFilter rounded conversation
    weightFilter(value) {
      return weightMixins.methods.mathRound(Number(value), 3)
    }
  },

  components: {
    VueHtml2pdf
  }
}
</script>
<style lang="scss">
#pdf-sale-invoice {
  * {
    font-family: unset;
  }

  html {
    line-height: unset;
    letter-spacing: unset;
  }

  table {
    margin: 0 auto;
  }

  body {
    color: #000;
  }

  th {
    border: 1px solid;
    padding: 4px;
    text-align: center;
  }

  #notices {
    width: 200px;
    margin-top: 10px;
    margin-left: 105px;
  }

  .sign {
    margin-top: 0px;
    margin-left: 545px;
    border-bottom: 2px solid black;
    width: 150px;
  }
}
</style>
